"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../../../constants/index.js");
var _index2 = require("../../../helpers/index.js");
var _index3 = require("../../../utils/index.js");
var _excluded = ["formName", "formType", "isLead", "leadType", "leadID", "email", "toolSelections"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var formTypes = _index.eventFieldValues.formTypes;
var stringField = _index2.formatters.stringField,
  listField = _index2.formatters.listField,
  hashField = _index2.formatters.hashField;

// Keys that cannot be customized since they have a default value or works with a custom behavior
var lockedFields = ['formComplete', 'leadComplete'];
var getFormCompleteTemplate = function getFormCompleteTemplate(_ref) {
  var formName = _ref.formName,
    formType = _ref.formType,
    _ref$isLead = _ref.isLead,
    isLead = _ref$isLead === void 0 ? false : _ref$isLead,
    leadType = _ref.leadType,
    leadID = _ref.leadID,
    email = _ref.email,
    toolSelections = _ref.toolSelections,
    rest = _objectWithoutProperties(_ref, _excluded);
  var cleanedRest = (0, _index3.removeLockedKeys)(rest, lockedFields);

  // TODO: remove formType evaluation from condition when formType field is deprecated
  var leadFields = isLead || formType === formTypes.LEAD ? {
    leadComplete: 1
  } : {};

  // Remove warning when formType field is deprecated
  if (formType) console.warn('alloyAnalytics: formType field will be deprecated from formComplete event in a next major release, use isLead field instead.');
  // TODO ends

  return {
    _telus: _objectSpread(_objectSpread({
      formComplete: 1,
      formName: stringField(formName),
      emailHash: hashField(email, {
        asEmail: true
      }),
      toolSelections: listField(toolSelections),
      leadType: stringField(leadType),
      leadID: leadID
    }, leadFields), cleanedRest)
  };
};
var _default = exports["default"] = getFormCompleteTemplate;